import { useState } from 'react';
import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/videos';
import type { VideoItem } from '@/mocks/videos';

export default function VideoGrid() {
  const [filter, setFilter] = useState<'all' | 'hot' | 'new'>('all');

  const displayVideos: VideoItem[] = (() => {
    if (filter === 'hot') return videos.filter((v) => v.isHot);
    if (filter === 'new') return videos.filter((v) => v.isNew);
    return videos;
  })();

  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-4">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              <i className="ri-video-line text-primary-500 mr-2"></i>
              视频大全
            </h2>
            <div className="hidden sm:flex items-center gap-1 bg-background-100 rounded-full p-1">
              {[
                { key: 'all', label: '全部' },
                { key: 'hot', label: '热门' },
                { key: 'new', label: '最新' },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setFilter(tab.key as typeof filter)}
                  className={`px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all cursor-pointer ${
                    filter === tab.key
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <a
            href="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
          {displayVideos.slice(0, 15).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}